/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Amorim API v1
 * Amorim API v1 — Public-facing endpoints (CMS, authentication, authenticated user resources, reservations).
 *
 * **Authentication**
 *
 * - All requests require an `Api-Key` header.
 * - Endpoints that operate on the authenticated user additionally require `Authorization: Bearer <jwt>`.
 * OpenAPI spec version: v1
 */
import type {
  GetBookableServicesV1Params,
  VenueServiceDto
} from '../model';

import { customFetch } from '../../../custom-fetch.ts';

export type getBookableServicesV1Response200 = {
  data: VenueServiceDto[]
  status: 200
}

export type getBookableServicesV1Response500 = {
  data: void
  status: 500
}

export type getBookableServicesV1ResponseSuccess = (getBookableServicesV1Response200) & {
  headers: Headers;
};
export type getBookableServicesV1ResponseError = (getBookableServicesV1Response500) & {
  headers: Headers;
};

export type getBookableServicesV1Response = (getBookableServicesV1ResponseSuccess | getBookableServicesV1ResponseError)

export const getGetBookableServicesV1Url = (params?: GetBookableServicesV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/reservations/services?${stringifiedParams}` : `/api/v1/reservations/services`
}

/**
 * Returns published, active bookable services enriched with venue and service-category data from the CMS (culture-aware via Accept-Language). Filter by serviceCategoryNodeKey (O quê?) and/or locationNodeKey (Onde?).
 * @summary Discover bookable services
 */
export const getBookableServicesV1 = async (params?: GetBookableServicesV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getBookableServicesV1Response> => {

  return customFetch<getBookableServicesV1Response>(getGetBookableServicesV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}


